import { Component } from '@angular/core';
import { LegacyWidgetComponentBase } from '../widget.class';
import { SurfaceWaterChart } from '../charts/surfaceWaterChart';
import { FilterService } from '@app/data/services/filterService';
import { LegacyDataService } from '@app/data/services/legacyDataService';
import { ClientService } from '@app/client/client.service';
import { AlertService } from '@app/data/services/alerts.service';
import { EChartsOption } from 'echarts';

import { forkJoin } from 'rxjs';
import { take } from 'rxjs/operators';
import { ClientConstantType } from '@app/client/client.constant';

@Component({
  selector: 'legacy-app-widget-swc',
  templateUrl: './widget-swc.component.html',
  styleUrls: ['./widget-swc.component.scss'],
})
export class WidgetSWCComponent extends LegacyWidgetComponentBase {
  surfaceWaterGrabOption: EChartsOption = {};
  chartTitle: string =
    this.clientService.getClient() === ClientConstantType.wastemanagement ? 'Wai - Surface Water' : 'Water Quality';
  chartHeader: string =
    this.clientService.getClient() === ClientConstantType.wastemanagement ? 'Kate Creek Wetland (SWC)' : 'Site 1';

  constructor(
    private surfaceWaterChart: SurfaceWaterChart,
    protected filterService: FilterService,
    protected legacyDataService: LegacyDataService,
    protected clientService: ClientService,
    private alertService: AlertService
  ) {
    super(filterService, legacyDataService, clientService);
  }

  onFilterUpdate(): void {
    forkJoin({
      surfacewater: this.legacyDataService.getSurfaceWaterData(this.fromDate, this.toDate).pipe(take(1)),
      alerts: this.alertService
        .search({
          startDate: this.fromDate,
          endDate: this.toDate,
          params: ['Boron', 'Zinc', 'Nitrate Nitrogen', 'Ammoniacal Nitrogen'],
        })
        .pipe(take(1)),
    }).subscribe((result) => {
      const { surfacewater, alerts } = result;
      // Filter the alerts for non-SWD
      const filteredAlerts = alerts.filter((a: any) => !a.name.includes('SWD'));
      const filteredResult = { surfacewater, alerts: filteredAlerts };

      // check if no data returned from selected dates
      if (surfacewater.length === 0) {
        // set echart options for grab data by location
        this.surfaceWaterGrabOption = this.surfaceWaterChart.getSurfaceWaterData([]).C;
      } else {
        // set echart options for grab data by location
        this.surfaceWaterGrabOption = this.surfaceWaterChart.getSurfaceWaterData(
          filteredResult,
          this.client === ClientConstantType.wastemanagement
        ).C;
      }
    });
  }
}
